import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, Check } from 'lucide-react';
export function Guarantee() {
  const promises = ['Probás el sistema con tranquilidad', 'Si no es para vos, te devolvemos todo', 'Sin formularios, sin preguntas, sin drama'];
  return <section className="py-16 md:py-24 bg-brand-dark" data-id="element-119">
      <div className="container mx-auto px-4" data-id="element-120">
        <div className="max-w-2xl mx-auto text-center" data-id="element-121">
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} className="flex flex-col items-center" data-id="element-122">
            {/* Badge circle */}
            <div className="relative mb-8" data-id="element-123">
              <div className="absolute inset-0 bg-brand-green/20 blur-2xl rounded-full" data-id="element-124" />
              <div className="relative w-28 h-28 md:w-32 md:h-32 rounded-full bg-gradient-to-br from-brand-green/20 to-brand-green/5 border-2 border-brand-green/50 flex flex-col items-center justify-center" data-id="element-125">
                <ShieldCheck className="w-10 h-10 md:w-12 md:h-12 text-brand-light mb-1" data-id="element-126" />
                <div className="text-xs font-bold text-brand-light tracking-wider" data-id="element-127">
                  21 DÍAS
                </div>
              </div>
            </div>

            <h2 className="text-3xl md:text-5xl font-bold mb-4 font-[Poppins,_sans-serif]" data-id="element-128">
              Riesgo cero para vos
            </h2>

            <p className="text-lg md:text-xl text-gray-300 mb-10 max-w-xl leading-relaxed" data-id="element-129">
              Tenés{' '}
              <span className="text-brand-light font-bold" data-id="element-130">
                21 días completos
              </span>{' '}
              para probar el sistema. Si no es lo que esperabas, te devolvemos
              el 100% de tu dinero.
            </p>

            {/* Clean promise list */}
            <div className="w-full bg-brand-black border border-brand-green/30 rounded-2xl p-6 md:p-8 mb-8" data-id="element-131">
              <div className="space-y-4" data-id="element-132">
                {promises.map((promise, i) => <div key={i} className="flex items-center gap-3 text-left" data-id="element-133">
                    <div className="w-6 h-6 rounded-full bg-brand-green/20 border border-brand-green/50 flex items-center justify-center shrink-0" data-id="element-134">
                      <Check className="w-3.5 h-3.5 text-brand-light" strokeWidth={3} data-id="element-135" />
                    </div>
                    <p className="text-gray-200 text-base md:text-lg" data-id="element-136">
                      {promise}
                    </p>
                  </div>)}
              </div>
            </div>

            <p className="text-sm text-gray-500" data-id="element-137">
              El riesgo lo asumimos nosotros. Vos solo probás.
            </p>
          </motion.div>
        </div>
      </div>
    </section>;
}